import axios from "axios";

const saveGamesSettings = async (formdata) => {
    try {
        const response = await axios.post('/api/games/save-games-config', formdata);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Unexpected response status while saving game settings.');
        }
    } catch (error) {
        console.error('Error in saving game settings:', error.message || error);
        throw new Error('Failed to save game settings. Please check your input and try again.');
    }
};

const getGamesSettings = async (formdata) => {
    try {
        const response = await axios.post('/api/games/get-games-config', formdata);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Unexpected response status while fetching game settings.');
        }
    } catch (error) {
        console.error('Error in fetching game settings:', error.message || error);
        throw new Error('Failed to fetch game settings. Please try again later.');
    }
};

const listOtpTemplates = async () => {
    try {
        const response = await axios.post('/api/games/otp-templates/list', {});
        return response.data;
    } catch (error) {
        console.error('Error in fetching OTP templates:', error.message || error);
        throw new Error('Failed to fetch OTP templates. Please try again later.');
    }
};

const createOtpTemplate = async (payload) => {
    try {
        const response = await axios.post('/api/games/otp-templates/create', payload);
        return response.data;
    } catch (error) {
        console.error('Error in creating OTP template:', error.message || error);
        throw new Error('Failed to create OTP template. Please check your input and try again.');
    }
};

const fetchGameDetails = async (formdata) => {
    try {
        formdata.bypass_status_filter = true; // To fetch all games including inactive ones
        const response = await axios.post('/api/games/get-game-details', formdata);
        return response.data;
    } catch (error) {
        console.error('Error in fetching game details:', error.message || error);
        throw new Error('Failed to fetch game details. Please try again later.');
    }
};

const fetchGames = async (formdata) => {
    try {
        const response = await axios.post('/api/games/get-games', formdata);
        return response.data;
    } catch (error) {
        console.error('Error in fetching games:', error.message || error);
        throw new Error('Failed to fetch games. Please try again later.');
    }
};
const getArticleTitle = async (projectId, formdetails, page, records) => {
    const formdata = {
        projectId: projectId,
        filters: formdetails,
        page: page,
        records: records
    };
    try {
        const response = await axios.post('/api/games/get-article-title', formdata);
        return response.data;
    } catch (error) {
        console.error('Error fetching article title:', error);
        throw new Error('Failed to fetch article title. Please try again later.');
    }
};

// List via existing get-game-details
const listCustomQuizzes = async ({ project_id, page = 1, limit = 10, game_type = 'custom_quiz', start_date, end_date, custom_quiz_id }) => {
    try {
        const payload = { project_id, game_type, page, limit };
        if (start_date) payload.start_date = start_date;
        if (end_date) payload.end_date = end_date;
        if (custom_quiz_id) payload.custom_quiz_id = custom_quiz_id;
        payload.bypass_status_filter = true; // To fetch all games including inactive ones
        const response = await axios.post('/api/games/get-game-details', payload);
        return response.data;
    } catch (error) {
        console.error('Error listing custom quizzes:', error.message || error);
        throw new Error('Failed to list custom quizzes.');
    }
};

const upsertCustomQuiz = async (formdata) => {
    try {
        const response = await axios.post('/api/games/custom-quiz/upsert', formdata);
        return response.data;
    } catch (error) {
        console.error('Error upserting custom quiz:', error.message || error);
        throw new Error('Failed to save custom quiz.');
    }
};

const setCustomQuizStatus = async (formdata) => {
    try {
        const response = await axios.post('/api/games/custom-quiz/status', formdata);
        return response.data;
    } catch (error) {
        console.error('Error setting custom quiz status:', error.message || error);
        throw new Error('Failed to update custom quiz status.');
    }
};

// Leaderboard APIs
const getLeaderboard = async (payload) => {
    const response = await axios.post('/api/games/leaderboard', payload);
    return response.data;
};

const getLeaderboardCharts = async (payload) => {
    const response = await axios.post('/api/games/leaderboard/charts', payload);
    return response.data;
};

const getGamesUserDetails = async (payload) => {
    const response = await axios.post('/api/games/leaderboard/user', payload);
    return response.data;
};

const exportGameLeaderboard = async (payload, responseType = 'json') => {
    const config = {
        ...(responseType === 'blob' && { responseType: 'blob' }),
    };

    const response = await axios.post(
        '/api/games/leaderboard/export',
        payload,
        config
    );

    return responseType === 'blob' ? response : response.data;
};

const gamesService = {
    saveGamesSettings,
    getGamesSettings,
    listOtpTemplates,
    createOtpTemplate,
    fetchGames,
    fetchGameDetails,
    getArticleTitle,
    listCustomQuizzes,
    upsertCustomQuiz,
    setCustomQuizStatus,
    getLeaderboard,
    getLeaderboardCharts,
    getGamesUserDetails,
    exportGameLeaderboard,
};

export default gamesService;
